import React from 'react'
import { observer } from 'mobx-react'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import { PaginationBody } from '@Entities/pagination'
import PaginationAndLimit from '@Components/Navigations/PaginationAndLimit'
import { SearchPartyStore } from '@App/stores/search/party/search-party-store'

interface PartyResultsTableProps<resultType> {
    onTitleClick(partyDetails: resultType): void
    searchPartyStore: SearchPartyStore<resultType>
    setLoading(loading: boolean): void
    PartyDetailsCardComponent: React.ComponentType<{
        partyDetails: resultType
        onTitleClick: (partyDetails: resultType) => void
    }>
}

const PartyResultsTable = <resultType,>(props: PartyResultsTableProps<resultType>) => {
    const { onTitleClick, searchPartyStore, setLoading, PartyDetailsCardComponent } = props

    const onPageChange = async (pagination: PaginationBody) => {
        setLoading(true)
        await searchPartyStore.search(pagination).finally(() => setLoading(false))
    }

    const onLimitChange = async (newLimit: number) => {
        setLoading(true)
        await searchPartyStore.setPageLimit(newLimit).finally(() => setLoading(false))
    }

    const count = searchPartyStore.totalNumberOfResults
    const searchResults = searchPartyStore.searchResults

    return (
        <div className="party-results-table">
            {searchResults && count > 0 && (
                <div className="found-items-wrapper">
                    <PaginationResultsBlock
                        totalResults={count}
                        workNumTitles={searchPartyStore.numTitles}
                        justResults={false}
                    />
                    <section className="items-container">
                        {searchResults.map((partyDetails: resultType, index: number) => (
                            <PartyDetailsCardComponent
                                key={index}
                                partyDetails={partyDetails}
                                onTitleClick={onTitleClick}
                            />
                        ))}
                    </section>
                    <PaginationAndLimit
                        paginationInfo={searchPartyStore.searchByCriteriaPaginationInfo}
                        onPageChange={onPageChange}
                        onLimitChange={onLimitChange}
                        count={count}
                        limit={searchPartyStore.resultsPerPageLimit}
                    />
                </div>
            )}
        </div>
    )
}

export default observer(PartyResultsTable)
